import { render, staticRenderFns } from "./MentorSignUp.vue?vue&type=template&id=7ee80299&"
import script from "./MentorSignUp.vue?vue&type=script&lang=js&"
export * from "./MentorSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports